// Shared formatting helpers for the Desarrollos operator surfaces.
// Salvadoran Spanish, no i18n dependency — same approach as the Recepción
// Digital module's timeAgoEs.

// "hace un momento" / "hace 5 min" / "hace 3 h" / "hace 2 días"
export const timeAgoEs = (iso) => {
  if (!iso) return '—';
  const mins = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 1) return 'hace un momento';
  if (mins < 60) return `hace ${mins} min`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `hace ${hours} h`;
  const days = Math.floor(hours / 24);
  return days === 1 ? 'hace 1 día' : `hace ${days} días`;
};

export const formatUsd = (n) =>
  `$${Number(n || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

// Start of the current calendar month, as an ISO string, for the "del mes"
// filters. Computed in the operator's local timezone rather than with the
// server's date_trunc('month', now()) so the number on screen matches the
// month boundary the operator actually lives in.
export const monthStartISO = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1).toISOString();
};

// Intake source_type → Spanish label. Values are constrained by
// desarrollos_intake_events_source_type_check.
const SOURCE_LABELS = {
  image: ['imagen', 'imágenes'],
  factura: ['factura', 'facturas'],
  voice: ['nota de voz', 'notas de voz'],
  manual: ['entrada manual', 'entradas manuales'],
  whatsapp: ['mensaje', 'mensajes'],
};

// [{source_type}] → [{ key, label }] e.g. "2 imágenes", "1 factura"
export const summarizeIntake = (events) => {
  const counts = {};
  (events || []).forEach((e) => {
    counts[e.source_type] = (counts[e.source_type] || 0) + 1;
  });
  return Object.entries(counts).map(([key, n]) => {
    const pair = SOURCE_LABELS[key] || [key, key];
    return { key, label: `${n} ${n === 1 ? pair[0] : pair[1]}` };
  });
};
